function popup(){
     const triggers = document.querySelectorAll('.video_play_link');
     if(!triggers){ return null; }

     triggers.forEach(trigger => {
          trigger.addEventListener('click', function(e){
               e.preventDefault();
               const target = this.getAttribute('data-target');
               document.querySelector(`[data-popup = '${target}']`).classList.add('active');
               document.querySelector(`[data-popup = '${target}'] video`).play();
               return null;
          })
     })

     const mobilClose = document.querySelectorAll('.mobile__close');
     if(mobilClose){
          mobilClose.forEach(close => {
               close.addEventListener('click', function(){
                    document.querySelector('.popup_container.active video').pause();
                    document.querySelector('.popup_container.active').classList.remove('active');
                    return null;
               }, false)
          })
     }
     return;
}

export default popup;